// extracted by mini-css-extract-plugin
export default {"image":"Image_image__djrsp","fade":"Image_fade__QSlAS","br":"Image_br__VyI-g"};